import { Button } from "@cede/ds";
import { useParamsForms } from "../hooks/useParamsForms/useParamsForms";
import { Box, useTheme, Typography, Switch, styled, Stack } from "@mui/material";

const AntSwitch = styled(Switch)(({ theme }) => ({
  "width": 28,
  "height": 16,
  "padding": 0,
  "display": "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    "padding": 2,
    "&.Mui-checked": {
      "transform": "translateX(12px)",
      "color": "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));
export const Settings = () => {
  const theme = useTheme();
  const mode = useParamsForms((state) => state.mode);
  const toggleMode = useParamsForms((state) => state.toggleMode);
  const allowPersistence = useParamsForms((state) => state.persist);
  const togglePersistence = useParamsForms((state) => state.togglePersist);
  const resetForms = useParamsForms((state) => state.resetForms);

  return (
    <Box
      zIndex={theme.custom.zIndex.topLayer}
      position={"fixed"}
      right={"1vw"}
      top={"1vw"}
      display={"flex"}
      flexDirection={"column"}
      gap={theme.custom.gutterMargin}
      padding={theme.custom.gutterMargin}
      sx={{
        backgroundColor: theme.palette.background.darkPaper,
      }}
    >
      <Box display={"flex"} alignItems={"center"} gap={theme.custom.bigGutterMargin}>
        <Typography fontWeight={"bold"}>Mode</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>User</Typography>
          <AntSwitch checked={mode === "json"} onChange={toggleMode} />
          <Typography>JSON</Typography>
        </Stack>
      </Box>
      <Box display={"flex"} alignItems={"center"} gap={theme.custom.bigGutterMargin}>
        <Typography fontWeight={"bold"}>Save data</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>Off</Typography>
          <AntSwitch checked={allowPersistence} onChange={togglePersistence} />
          <Typography>On</Typography>
        </Stack>
      </Box>
      <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"} gap={theme.custom.bigGutterMargin}>
        <Button onClick={resetForms}>Reset forms</Button>
      </Box>
    </Box>
  );
};
